import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-16 px-5 md:px-6 bg-white" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#A9D7E2] text-[#2D1F1A] p-6 md:p-10 rounded-3xl text-center relative overflow-hidden" data-id="element-67">
          <div className="absolute -top-10 -right-10 text-[#F9A8B7] opacity-20" data-id="element-68">
            <ShieldCheckIcon className="w-48 h-48" data-id="element-69" />
          </div>
          <div className="relative z-10" data-id="element-70">
            <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#F9A8B7] rounded-full mb-4 md:mb-6 shadow-md" data-id="element-71">
              <ShieldCheckIcon className="w-7 h-7 md:w-8 md:h-8 text-white" data-id="element-72" />
            </div>
            <h2 className="text-2xl md:text-5xl font-bold mb-3 md:mb-5 tracking-tight leading-tight" data-id="element-73">
              GARANTÍA{' '}
              <em className="text-white not-italic drop-shadow-sm" data-id="element-74">
                "ÁMALA O DEVUÉLVELA"
              </em>
            </h2>
            <p className="text-base md:text-2xl text-[#2D1F1A]/80 leading-snug md:leading-relaxed max-w-2xl mx-auto" data-id="element-75">
              Pruébala{' '}
              <span className="font-bold text-[#2D1F1A] underline decoration-[#F9A8B7] decoration-2 underline-offset-4" data-id="element-76">
                7 días completos
              </span>
              . Si no te gusta, te devuelvo el{' '}
              <span className="font-bold text-[#2D1F1A]" data-id="element-77">
                100% de tu dinero
              </span>
              . <em data-id="element-78">Sin preguntas. Sin formularios. Sin culpa.</em>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}